import { Route } from "@angular/router";


export const tarjetaDigitalRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./pages/create/create.component').then(c => c.CreateComponent), 
  }
]